
<template>
    <div class="login_remis_customer row">
        <div class="col-md-6 login_remis_first_section">
            <img src="https://epump.com.ng/images/logo2.svg" class="company_logo" width="150"/>

            <div class="login_remis_text">{{$t('text.registrationCompleted.title')}}</div>
            <p class="primary-color"> {{$t('text.registrationCompleted.linkSent')}}</p>
            <p class="primary-color">{{$t('text.registrationCompleted.pleaseCheck')}}
                {{$t('text.registrationCompleted.toConfirm')}}</p>

             <div class="row m-hide">
                    <div class="col-md-6 col-sm-12 login-remis-img remove-left-padding">
                        <img src="https://eterna.epump.ng/img/fleet.1df15d9f.png" class="w-100" />
                    </div>
                    <div class="col-md-6 col-sm-12 login-remis-img remove-left-padding ">
                        <img src="https://eterna.epump.ng/img/remis-second.59860c23.png" class="w-100"/>
                    </div>
                    <div class="col-md-6 col-sm-12 login-remis-img mt-3  remove-left-padding">
                        <img src="https://eterna.epump.ng/img/motorbike-fleet-serces.1b139bfe.png" class="w-100"/>
                    </div>
                    <div class="col-md-6 login-remis-img mt-3 remove-left-padding">
                        <img src="https://eterna.epump.ng/img/remis-third.f02ee4d4.png" class="w-100" />
                    </div>
                </div>
        </div>
        <div class="col-md-6">
            <section class="small-login-wrapper">
                <div class="text-center ">
                    <transition name="fade" mode="out-in" appear>
                            <div class="img_section">
                            <img src="@/assets/img/Group296.png"  width="70%"  />
                        </div>
                    </transition>
                    <div class="text-center mt-5">
                        <button type="submit" class="btn dealers_btn" @click="goToLoginRoute">{{$t('text.registrationCompleted.backToLogin')}}</button>
                    </div>
                </div>
            </section>
        </div>
    </div>
   
</template> 
<script>
import backgroundUrl from '@/assets/img/img_2.jpg'; 
export default {
    title: "Registration Completed:: Epump Portal",
    name: "Login",
    data(){
        return {
            backgroundUrl,
            formIsValid: false,
            disabled: true,
            signup: false,
            email: null,
            password: "",
            formStatus: "signup",
            emailQueryParam: this.$route.query.userEmail
        }
    },
    methods: {
        goToLoginRoute() {
            this.$router.push("/");
        }
    }
}
</script>

